import { createGlobalStyle } from "styled-components";
import AuthImage from "../assets/icons/AuthBackgroundImage.svg";

export const AuthBackgroundStyle = createGlobalStyle`
  body {
    background-color:#FAE7D9;
    background-image:url(${AuthImage});
    background-repeat: no-repeat;
    background-position:center;
    min-height:100vh;
  }
`;
export const theme = {
  colors: {
    /* Primary Colors */
    primary: "#E95B2E",
    primaryLighter: "#f5cdb3",
    success: "#A6D673",
    error: "#F85959",
    info: "#337FDE",
    warning: "#E1C52C",

    /* All Colors */
    white: "#FFFFFF",
    black: "#000000",
    dark: "#242424",
    orange: "#fb8c00",

    /* Gray Scale */
    gray1: "#F9F9F9",
    gray2: "#E2E2E2",
    gray3: "#CBCBCB",
    gray4: "#B3B3B3",
    gray5: "#9C9C9C",
    gray6: "#858585",

    /* Blue */
    blueMain: "#194071",
    blueBackground: "#90B4E0",

    /* Light Blue */
    lightBlue: "#e9f0f9",
    lightBlueBackground: "#f3f7fb",

    /* Dark Green */
    darkGreenMain: "#25816F",
    darkGreenHover: "#0F4E42",
    darkGreenFocus: "#45B49E",
    darkGreenBackground: "#F1FFFC",

    /* Violet */
    violetMain: "#715785",
    violetHover: "#4D395C",
    violetFocus: "#9678AE",
    violetBackground: "#FCF9FF",

    /* Yellow */
    yellowMain: "#E5E12E",
    yellowHover: "#E5E12E",
    yellowFocus: "#FFFC70",
    yellowBackground: "#FFFEEA",

    /* Light red */
    lightRedMain: "#E99082",
    lightRedHover: "#B6695D",
    lightRedFocus: "#F5C1B9",
    lightRedBackground: "#FFF5F3",

    /* Pomade */
    pomade: "#FADDC3",

    /* Haki */
    haki: "#D8E8C6",

    /* Blue Violet */
    blueViolet: "#F4F8FF",

    /* Green */
    greenMain: "#7CB341",
    greenHover: "#548025",
    greenFocus: "#A8E665",
    greenBackground: "#F8FFF0",

    /* Red */
    redMain: "#DB2136",
    redHover: "#970415",
    redFocus: "#F96575",
    redBackground: "#FFE9EB",

    /* Transparent */
    transparent: "transparent",
    transparentBlack1: "rgba(0, 0, 0, 0.08)",
    transparentBlack2: "rgba(0, 0, 0, 0.14)",
    transparentBlack3: "rgba(0, 0, 0, 0.20)",
    transparentBlack4: "rgba(0, 0, 0, 0.26)",
    transparentBlack5: "rgba(0, 0, 0, 0.32)",

    lightStone: "#E1EAEE",
  },
};
